import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Prompt } from 'react-router-dom';

import _ from 'lodash';
import * as Actions from '../store/actions';
import * as TimerActions from 'main/components/timer/store/actions';
import StudentQuestion from './StudentQuestion';
import QuizHeader from './QuizHeader';
import Timer from 'main/components/timer/Timer';
import TabPanelButtons from 'main/components/TabPanelButtons';

import { FusePageCarded, FuseAnimate } from '@fuse';
import {
    Tabs,
    Card,
    Button,
    CardContent,
    CardActions,
    Icon,
    Typography,
    Grid,
    Divider,
} from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    // actions: {
    //     display: 'flex'
    // },
});

class QuizViewer extends Component {
    state = {
        quiz_id: 0,
        event_id: 0,
    }

    constructor(props) {
        super(props);

        this.state.event_id = (this.props.match.params.event_id || 0);
        this.state.quiz_id = (this.props.match.params.quiz_id || 0);
        const student_id = this.props.user.data.role_info.link_id;

        if (this.state.event_id !== 0) {
            this.props.getNextEventForContinueButton(this.props.match.params.event_id, 0, student_id);
            this.props.getCourseInfo(this.state.event_id)
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const event_id = this.props.match.params.event_id;
        const quiz_id = this.props.match.params.quiz_id;
        if (
            !_.isEqual(event_id, prevProps.match.params.event_id)
            ||
            !_.isEqual(quiz_id, prevProps.match.params.quiz_id)
        ) {
            const { getQuizByEventID, clearStudentAnswers, getAttemptList, getQuiz, getAuthAttemptList } = this.props;
            const { user, getQuizGradebookInfoByEventID } = this.props;

            this.setState({
                event_id, quiz_id
            })

            let student_id = 0;
            if (user.role === "student") {
                student_id = user.data.role_info.link_id;
            }
            if (this.state.quiz_id !== 0) {
                // If Auth/Instructor is testing quiz
                getQuiz(this.state.quiz_id, true);
                getAuthAttemptList(this.state.quiz_id, user.data.auth_id);
                clearStudentAnswers();
            } else {
                // If Student is taking quiz normally
                getQuizByEventID(event_id, true, student_id);
                getQuizGradebookInfoByEventID(event_id, student_id);
                getAttemptList(event_id, student_id);
                clearStudentAnswers();
                this.props.getNextEventForContinueButton(this.props.match.params.event_id, 0, student_id);
                this.props.getCourseInfo(this.state.event_id);
            }
        }
    }

    componentDidMount = () => {
        const { getQuizByEventID, clearStudentAnswers, getAttemptList, getQuiz, getAuthAttemptList } = this.props;
        const { user, getQuizGradebookInfoByEventID } = this.props;

        let student_id = 0;
        if (user.role === "student") {
            student_id = user.data.role_info.link_id;
        }

        if (this.state.quiz_id !== 0) {
            // If Auth/Instructor is testing quiz
            getQuiz(this.state.quiz_id, true);
            getAuthAttemptList(this.state.quiz_id, user.data.auth_id);
            clearStudentAnswers();
        } else {
            // If Student is taking quiz normally
            getQuizByEventID(this.state.event_id, true, student_id);
            getQuizGradebookInfoByEventID(this.state.event_id, student_id);
            getAttemptList(this.state.event_id, student_id);
            clearStudentAnswers();
        }

        // window.addEventListener('beforeunload', this.handleSubmitQuiz);
    }

    componentWillUnmount = () => {
        const { inProgress, endTimer } = this.props;

        if (inProgress) {
            endTimer();
        }
        // window.removeEventListener('beforeunload', this.handleSubmitQuiz);
    }

    handleQuizStart = () => {
        const { startTimer, setQuizInProgress, setQuestion, createStudentQuizHeader, user, quiz } = this.props;

        let student_id = 0;
        if (user.role === "student") {
            student_id = user.data.role_info.link_id;
        }

        createStudentQuizHeader(this.state.event_id, quiz.header.quiz_id, student_id, user.data.auth_id);
        setQuestion(0);

        startTimer(quiz.header.TimeLimit, this.handleSubmitQuiz);
        setQuizInProgress(true);
    }

    handleSubmitQuiz = () => {
        const { studentAnswers, timeTaken, student_quiz_id } = this.props;
        const { submitStudentAnswers, resetTimer } = this.props;

        resetTimer();
        submitStudentAnswers(student_quiz_id, timeTaken, studentAnswers, this.handleRedirect);
    }

    handleRedirect = () => {
        const { student_quiz_id } = this.props;

        this.props.history.push('/quiz/score/' + student_quiz_id);
    }

    generateCardActions = () => {
        const { attempt, classes, currentQuestionIndex, match, quiz, setQuestion, studentAnswers, timeTaken } = this.props;
        const { MaxAttempt = 0 } = quiz.header;
        const attemptOffset = 1;
        const unlimitedAttempts = 0;
        const isBelowMax = attempt - attemptOffset < MaxAttempt;
        const isUnlimited = MaxAttempt === unlimitedAttempts;
        const isEnabled = isBelowMax || isUnlimited;
        const isTestPath = match.path.includes("test");

        const startEnabled = isEnabled && !isTestPath;

        let attempt_status = (attempt > quiz.header.MaxAttempt);

        if(this.props.quizGradebookInfo) {
            if (this.props.quizGradebookInfo.RetakeEvent === 1){
                attempt_status = false;
            }
        }

        // const attempt_status = false;
        if (this.props.user.role !== 'student') {
            attempt_status = false
        }

        if (currentQuestionIndex === 'header') {
            return (
                <React.Fragment>
                    <Button
                        variant="contained"
                        onClick={this.handleQuizStart}
                        disabled={!startEnabled}
                    >
                        Start
                    </Button>
                </React.Fragment>
            );
        } else if (currentQuestionIndex === 0 && quiz.questionList.length !== 1) {
            return (
                <React.Fragment>
                    <Button
                        variant="contained"
                        onClick={() => setQuestion('NEXT')}
                    >
                        Next
                    </Button>
                </React.Fragment>
            );
        } else if (currentQuestionIndex < quiz.questionList.length - 1) {
            return (
                <React.Fragment>
                    <Button
                        variant="contained"
                        onClick={() => setQuestion('PREVIOUS')}
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setQuestion('NEXT')}
                    >
                        Next
                    </Button>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <Button
                        variant="contained"
                        onClick={() => setQuestion('PREVIOUS')}
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        onClick={this.handleSubmitQuiz}
                    >
                        Submit
                    </Button>
                </React.Fragment>
            );
        }
    }

    generateHeader = () => {
        const { classes, quiz, studentAnswers, currentQuestionIndex, timeTaken, attempt } = this.props;

        if (currentQuestionIndex === 'header') {
            return (
                <div className="p-24">
                    <h4>
                        Quiz - {quiz.header.QuizName}
                    </h4>
                </div>
            );
        }

        return (
            <div className="p-24">
                <h4>
                    Quiz - {quiz.header.QuizName}
                </h4>
                <h4>
                    Time Left: <Timer />
                </h4>
                <h4>
                    Attempt #: {attempt}
                </h4>
            </div>
        );
    }

    generateToolbar = () => {
        const { classes, quiz, studentAnswers, currentQuestionIndex, timeTaken, attempt, user, nextEvent, courseInfo } = this.props;
        const { setQuestion } = this.props;
        if (currentQuestionIndex === 'header') {
            return (
                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant="h5">Quiz - {quiz.header.QuizName}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <div className="flex items-center justify-end" style={{ height: '64px' }}>
                            <TabPanelButtons
                                component_name = {"quiz"}
                                view_type      = {"detail"}
                                largeLabel // hack to get course dashboard button on one line
                                button_list    = {[
                                    {
                                        display:  "Back",
                                        type:     "back",
                                        onClick:  () => this.props.history.push(`/${this.props.prevEvent.EventType}/student/${this.props.prevEvent.company_calendar_event_id}`),
                                        disabled: !this.props.prevEvent,
                                        hidden:   this.props.user.role !== 'student',
                                    },
                                    {
                                        display: courseInfo.NewUserAuthRole === 0 ? 'Course Dashboard' : 'Course Menu',
                                        type:    "back",
                                        onClick: () => this.props.history.push('/course-dashboard/' + courseInfo.company_calendar_course_id + '/' + courseInfo.Unscheduled),
                                        hidden:  this.props.user.role !== 'student',
                                        largeLabel: true
                                    },
                                    {
                                        display:  "Next",
                                        type:     "back",
                                        onClick:  () => this.props.history.push(`/${this.props.nextEvent.EventType}/student/${this.props.nextEvent.company_calendar_event_id}`),
                                        disabled: this.props.attempt === 1 || !this.props.nextEvent,
                                        hidden:   this.props.user.role !== 'student',
                                    },
                                    {
                                        display: 'Back',
                                        type:    "back",
                                        onClick: () => this.props.history.push('/quiz/edit/' + this.props.quiz.header.quiz_id),
                                        hidden:  this.props.user.role === 'student',
                                    },
                                    // {
                                    //     type:    "back",
                                    //     onClick: this.props.history.goBack,
                                    //     hidden: this.props.user.role === 'student'
                                    // }
                                ]}
                            />
                        </div>
                    </Grid>
                </Grid>
            )
        } else {
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h5">Question #{currentQuestionIndex + 1}</Typography>
                    </Grid>
                </Grid>
            )
        }
    }

    render() {
        const { classes, quiz, studentAnswers, currentQuestionIndex, timeTaken, attempt, inProgress, courseInfo, user } = this.props;
        const cardActions = this.generateCardActions();
        const header = this.generateHeader();
        const toolbar = this.generateToolbar();

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={header}
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>{toolbar}</div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {currentQuestionIndex === 'header' ? <QuizHeader quiz={quiz} />
                                : <StudentQuestion
                                    question={quiz.questionList[currentQuestionIndex]}
                                    index={currentQuestionIndex}
                                />
                            }
                        </div>
                        <Divider />
                        <div className="p-24">
                            {cardActions}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQuiz: Actions.getQuiz,
        getQuizByEventID: Actions.getQuizByEventID,
        setQuestion: Actions.setQuestion,
        clearStudentAnswers: Actions.clearStudentAnswers,
        createStudentQuizHeader: Actions.createStudentQuizHeader,
        getAttemptList: Actions.getAttemptList,
        submitStudentAnswers: Actions.submitStudentAnswers,
        setQuizInProgress: Actions.setQuizInProgress,
        getAuthAttemptList: Actions.getAuthAttemptList,
        startTimer: TimerActions.startTimer,
        resetTimer: TimerActions.resetTimer,
        endTimer: TimerActions.endTimer,
        getNextEventForContinueButton: Actions.getNextEventForContinueButton,
        getCourseInfo: Actions.getCourseInfo,
        getQuizGradebookInfoByEventID: Actions.getQuizGradebookInfoByEventID
    }, dispatch);
}

function mapStateToProps({ quizApp, timer, auth }) {
    return {
        quiz: quizApp.quizzes.currentQuiz,
        studentAnswers: quizApp.quizViewer.studentAnswers,
        currentQuestionIndex: quizApp.quizViewer.currentQuestionIndex,
        attempt: quizApp.quizViewer.attempt,
        student_quiz_id: quizApp.quizViewer.student_quiz_id,
        inProgress: quizApp.quizViewer.inProgress,
        timeTaken: timer.timeTaken,
        user: auth.user,
        nextEvent: quizApp.quizScore.nextEvent,
        prevEvent: quizApp.quizScore.prevEvent,
        courseInfo: quizApp.quizViewer.courseInfo,
        quizGradebookInfo: quizApp.quizViewer.quizGradebookInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizViewer)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/QuizViewer.js